import axios from "./axios"

function create (data) {
    return axios().post("/debit-notes", data, {
        headers: {
            "X-Request-ID": data.idempotentKey
        }
    });
}

function findByID(id) {
    return axios().get(`/debit-notes/${id}`);
}

function remove(data) {
    return axios().delete(`/debit-notes/${data.id}`);
}

function index(params) {
    params = {...params, limit: params.itemsPerPage, offset: (params.page -1) * params.itemsPerPage};
    return axios().get(`/debit-notes`, {
        params
    });
}

function update (data) {
    return axios().put(`/debit-notes/${data.id}`, data);
}

function post(data) {
    return axios().put(`/debit-notes/${data.id}/post`, data);
}

function print(data) {
    return axios().get(`/debit-notes/${data.id}`, {
        headers: {
            "Accept": "text/html"
        }
    });
}
function states() {
    return axios().get('debit-note-states')
}

export default {
    create,
    findByID,
    remove,
    index,
    update,
    post,
    print,
    states
}